import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWithoutDepositTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const WithoutDepositTagItem = ({ onDeleteClick, withNewTag }: IWithoutDepositTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Без залога
    </TagComponent>
  );
};
